/**
 * PokeAlp — Product Card Hover Gallery v3
 *
 * Par défaut  : featured image visible (première <img> enfant).
 * Au hover    : slider des .pa-hover-gallery__slide par zone horizontale.
 * Au mouseleave : retour à la featured.
 */
(function () {
  'use strict';

  function initGallery(el) {
    var featured = el.querySelector(':scope > .pa-hover-gallery__featured');
    var slides = el.querySelectorAll(':scope > .pa-hover-gallery__slide');
    var dotsWrap = el.querySelector('[data-gallery-dots]');
    var total = slides.length;

    if (!featured || total === 0) return;

    var currentSlide = -1; /* -1 = featured affiché */

    /* Dots */
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var d = document.createElement('span');
        d.className = 'pa-hover-gallery__dot';
        dotsWrap.appendChild(d);
      }
    }

    function showFeatured() {
      if (currentSlide === -1) return;
      currentSlide = -1;
      featured.style.opacity = '1';
      featured.style.zIndex = '2';
      for (var k = 0; k < total; k++) {
        slides[k].style.opacity = '0';
        slides[k].style.zIndex = '1';
      }
      if (dotsWrap) {
        var dots = dotsWrap.children;
        for (var m = 0; m < dots.length; m++) {
          dots[m].classList.remove('is-active');
        }
      }
    }

    function showSlide(idx) {
      if (idx === currentSlide) return;
      currentSlide = idx;
      featured.style.opacity = '0';
      featured.style.zIndex = '1';
      for (var k = 0; k < total; k++) {
        slides[k].style.opacity = k === idx ? '1' : '0';
        slides[k].style.zIndex = k === idx ? '2' : '1';
      }
      if (dotsWrap) {
        var dots = dotsWrap.children;
        for (var m = 0; m < dots.length; m++) {
          dots[m].classList.toggle('is-active', m === idx);
        }
      }
    }

    el.addEventListener('mousemove', function (e) {
      var rect = el.getBoundingClientRect();
      var pct = (e.clientX - rect.left) / rect.width;
      var idx = Math.min(Math.floor(pct * total), total - 1);
      showSlide(idx);
    });

    el.addEventListener('mouseleave', function () {
      showFeatured();
    });

    el.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      var rect = el.getBoundingClientRect();
      var pct = (t.clientX - rect.left) / rect.width;
      var idx = Math.min(Math.floor(pct * total), total - 1);
      showSlide(idx);
    }, { passive: true });

    el.addEventListener('touchend', function () {
      showFeatured();
    });
  }

  function initAll() {
    var galleries = document.querySelectorAll('[data-hover-gallery]');
    for (var i = 0; i < galleries.length; i++) {
      if (!galleries[i].hasAttribute('data-hg-init')) {
        galleries[i].setAttribute('data-hg-init', '1');
        initGallery(galleries[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.MutationObserver) {
    new MutationObserver(function () {
      requestAnimationFrame(initAll);
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
})();
